<script lang="ts">
	import { PowerIcon } from "luxedo-icons"
	import { tooltip } from "tooltip"

	interface Props {
		isOn: boolean
		isChanging: boolean
		togglePower: () => void
	}

	let { isOn, isChanging, togglePower }: Props = $props()

	function getTooltip(on: boolean) {
		if (on) {
			return {
				content: "Power off projector",
				pointing: "top" as "top",
			}
		} else {
			return { content: "Power on projector", pointing: "top" as "top" }
		}
	}
</script>

<button
	class="small icon power-button {isOn ? 'ON' : 'OFF'} {isChanging ? 'changing' : ''}"
	title={getTooltip(isOn).content}
	onclick={isChanging ? undefined : togglePower}
	disabled={isChanging}
>
	<PowerIcon />
</button>

<style>
	.power-button.ON {
		--color-icon: var(--color-main);
	}

	.power-button.OFF {
		--color-icon: var(--color-text);
	}

	.power-button :global(.svg-fill) {
		fill: var(--color-icon);
		transition: fill 150ms;
	}

	@keyframes flashing {
		0% {
			--color-icon: var(--color-main);
		}

		50% {
			--color-icon: var(--color-text);
		}

		100% {
			--color-icon: var(--color-main);
		}
	}

	.power-button:disabled {
		opacity: 1;
	}

	.power-button.changing :global(.svg-fill) {
		animation-name: flashing;
		animation-duration: 2s;
		animation-iteration-count: infinite;
	}
</style>
